import { render } from "./Xianhuo.vue?vue&type=template&id=61638d76&scoped=true"
import script from "./Xianhuo.vue?vue&type=script&lang=js"
export * from "./Xianhuo.vue?vue&type=script&lang=js"

import "./Xianhuo.vue?vue&type=style&index=0&id=61638d76&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61638d76"]])

export default __exports__